class Validator {
  private errorMessages: any = {}

  public validateInputAccount (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = 'アカウント種別は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputName (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '氏名は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputTel (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '連絡先は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputEmail (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = 'メールアドレスは必ず入力してください。'
      return false
    } else if (value.match(/^([a-zA-Z0-9])+([a-zA-Z0-9._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9._-]+)+$/) === null) {
      this.errorMessages[key] = '正しいメールアドレスの形式で入力してください。'
      return false
    }
    return true
  }

  public validateInputPassword (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = 'パスワードは必ず入力してください。'
      return false
    } else if (!(value.match(/^[a-z\d!"'#$%&()_-]{6,128}$/i))) {
      this.errorMessages[key] = 'パスワードは半角英数字6文字以上128文字以内で入力してください。'
      return false
    }
    return true
  }

  public validateInputConfirmPassword (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '確認用パスワードは必ず入力してください。'
      return false
    } else if (!(value.match(/^[a-z\d!#$%&;]{6,128}$/i))) {
      this.errorMessages[key] = 'パスワードは半角英数字6文字以上128文字以内で入力してください。'
      return false
    }
    return true
  }

  public getErrorMessage () {
    return this.errorMessages
  }
}

export default new Validator()
